import { VALIDATE } from '@src/consts'

import {
  replaceCommaAndHalfWithDigitToEmpty,
  replaceCommaToEmpty,
} from '../str-converter'

/**
 * To convert a comma-delimited string into a numerical value for verification, do the following
 * - The following processing is required to validate that commas and single-byte numbers are left blank and that simple characters are included.
 * - The comma is left blank and validated as a numerical value.
 * @param value string
 * @returns boolean
 */
export function validTenBillionYen(value: string) {
  const character = replaceCommaAndHalfWithDigitToEmpty(value)
  if (character) return true

  const halfWidthDigit = replaceCommaToEmpty(value)
  const number = parseInt(halfWidthDigit, 10)
  if (isNaN(number)) return true

  return number <= VALIDATE.AMOUNT.MAX.VALUE
}

export function validMaxAmount(value: string, MAX_VALUE: number) {
  const character = replaceCommaAndHalfWithDigitToEmpty(value)
  if (character) return true

  const halfWidthDigit = replaceCommaToEmpty(value)
  const number = parseInt(halfWidthDigit, 10)
  if (isNaN(number)) return true

  return number <= MAX_VALUE
}

export function validISODate(value: string) {
  const regexISOYearMonthDay = /^\d{4}-\d{2}-\d{2}$/
  if (!regexISOYearMonthDay.test(value)) return false

  const date = new Date(value)
  const dateNum = date.getTime()
  if (!dateNum && dateNum !== 0) return false

  return date.toISOString().slice(0, 10) === value
}
